import { render, staticRenderFns } from "./UnderReview.vue?vue&type=template&id=582b274c&"
import script from "./UnderReview.vue?vue&type=script&lang=js&"
export * from "./UnderReview.vue?vue&type=script&lang=js&"
import style0 from "./UnderReview.vue?vue&type=style&index=0&id=582b274c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports